import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink,   CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'
import ReactTable from "react-table";
import "react-table/react-table.css";

import IconSave from 'react-icons/lib/md/save';
import IconEdit from 'react-icons/lib/md/edit';

import * as actions from '../../actions/cliente';

import Select from 'react-select';

import {api} from '../../actions/_request';
import ModalTablas from '../../components/catalogos/modal_tablas';
import Embarques from "../embarques/Modal";
import LAB from "../lab/Modal";
import Descuentos from "../descuentos/Modal";
import Terminos from "../terminospagos/Modal";

const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);

const codigos_precios = [
    {label: '1', value: 1},
    {label: '2', value: 2},
    {label: '3', value: 3},
    {label: '4', value: 4},
    {label: '5', value: 5}
];

class ClienteModal extends React.Component
{
    constructor(props)
    {
        super(props)

        this.state = {
            cliente: {
                activo:1,
                ciudad:'',
                codigo_comision:'',
                codigo_descuento:'',
                codigo_postal:'',
                codigo_precio:1,
                factura_electronica:false,
                lab:'',
                term_pago:'',
                fax:'',
                via_emb:'',
                cta_contable:'',
                dias_pago:0,
                dias_revision:0,
                enc_pagos:'',
                limite_credito:0,
                plazo_credito:0,
                zona:'',
                exceder_credito:false,
                mayoreo:false,
                modificar:false,
                vendedor_id:1,
                codigo_postal:'',
                id:0,
               cliente: '',
               contacto : '',
               correo : '',
               rSocial : '',
               rfc : '',
               domicilio : '',
               telefono: '',
               ciudad : '',
               tipo_id:1,
               nota:'',
               factura_calle:"",
                factura_cliente:"",
                factura_colonia:"",
                factura_condicion:"",
                factura_cp:"",
                factura_estado:"",
                factura_forma:1,
                factura_localidad:"",
                factura_metodo:1,
                factura_municipio:"",
                factura_num_ext:"",
                factura_num_int:"",
                factura_pais:"",
                factura_referencia:"",
                factura_uso_id:1,
                factura_pais_id:151,

            },
            usuario:
            {
                id:null,
                name:"",
                email:"",
                password:"",
                departamento:10,
                rol:0,
                cliente_id:this.props.prospectoid,

            },
            tipos:[],
            usuarios : [],
             formas : [],
              metodos : [],
            action: 'save_cliente',
            activeTab: '1',
            modal:false,
            titulo:'',
            tabla_modal:0,
            campo_modal:'',

            codigo_lab:'',
            codigo_via_emb:'',
            codigo_descuento:'',
            codigo_terminos:'',
            codigo_pais:'MEX',

            /*modal para agrgar nuevos registros*/
            modal_registro:0,
            tittle_registro:'',

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChange2 = this.handleInputChange2.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.CrearUsuario = this.CrearUsuario.bind(this);
        this.resetModal= this.resetModal.bind(this);
        this.handleChangeTipo= this.handleChangeTipo.bind(this);
        this.handleChangerfc= this.handleChangerfc.bind(this);
        this.toggle_tab= this.toggle_tab.bind(this);
        this.handleSelectChange= this.handleSelectChange.bind(this);
        this.toggle_modal= this.toggle_modal.bind(this);  
        this.retorno= this.retorno.bind(this);
        this.ChangeCode= this.ChangeCode.bind(this);
        this.handleClose= this.handleClose.bind(this);
        this.toggle_modal_registro= this.toggle_modal_registro.bind(this);          
    }
    handleClose (event) {
         
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        
        let campo="";
        let tabla=""

        
        switch (name) {
            case "codigo_lab":                 
                  campo = "lab";
                  tabla="/lab";
                  break;
            case "codigo_via_emb":                  
                  campo = "via_emb";
                  tabla="/embarque";
                  break;
            case "codigo_descuento":                 
                  campo = "codigo_descuento";
                  tabla="/descuentof";
                  break;
            case "codigo_terminos":                  
                  campo = "term_pago";
                  tabla="/terminos_pago";
                  break; 
            case "codigo_pais":                  
                  campo = "factura_pais_id";
                  tabla="/sat/paises_codigo";
                  break;
            case "clave_banco":                 
                  campo = "banco_id";
                  tabla="/sat/banco_codigo";
                  break; 
 
        }
        let self =this;
        if(value!=""){
            api().get(`${tabla}/${value}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                    let vaciar=0;
                     if(Object.keys(response.data).length > 0){
                       
                       
                     }  else{
                         vaciar=1
                         swal("Oops..", "No Existe el Codigo");
                     }
                     self.retorno(response.data,campo,vaciar,value);        
                   
                }

            });
        }else{
            self.retorno([],campo,1,value); 
        }
            

   }

    ChangeCode(event) {
     
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
     
        this.setState({
            [name] : value
        });
    }
     modal_open(){
       document.getElementById('body').className = "modal-open modal-open";
    }

    toggle_modal_registro(objeto,opcion=0,titulo=''){
      // console.log('opcion---->'+opcion);
      if(opcion==0||opcion=='[object Event]'){
        // console.log('se agrega un modal-open')
        setTimeout(this.modal_open, 1000);
         
         //if(this.state.tabla_modal==14)
        //  document.getElementById('body').className = "modal-open modal-open";

        this.setState({
            modal : false,
            modal_registro:this.state.tabla_modal,
            tittle_registro:titulo,
            titulo:"",
            tabla_modal:"",
            campo_modal:"",         
        })

      }else{
// console.log('nada')
        this.setState({
            modal : !this.state.modal,
            modal_registro:this.state.tabla_modal,
            tittle_registro:titulo,
            titulo:"",
            tabla_modal:"",
            campo_modal:"",         
        })

      }
    }

    toggle_modal(index=0,catalogo="",campo=""){  

        this.setState({
            modal : !this.state.modal,
            titulo:catalogo,
            tabla_modal:index,
            campo_modal:campo,         
        })
    }

     retorno(objeto,campo,vacio=0,valor=""){
        let codigo="";
        let campo_codigo="";
        console.log('renglon---->',objeto);
        let {cliente} = this.state;
        let self =this;
         let rfc_banco="";
        let nombre_banco="";
        switch (campo) {
            case "lab":
                  codigo=objeto.value?objeto.value:objeto.id;
                  campo_codigo="codigo_lab"; 
                  cliente[campo] = objeto.value?objeto.value:objeto.id;
                  break;
            case "via_emb":
                  codigo=objeto.value?objeto.value:objeto.id;
                  campo_codigo="codigo_via_emb";
                  cliente[campo] = objeto.value?objeto.value:objeto.id;
                  break;
            case "codigo_descuento":
                  codigo=objeto.value?objeto.value:objeto.id;
                  campo_codigo="codigo_descuento"; 
                  cliente[campo] = objeto.value?objeto.value:objeto.id;
                  break;
            case "term_pago":
                  codigo=objeto.value?objeto.value:objeto.id;
                  campo_codigo="codigo_terminos";
                  cliente[campo] = objeto.value?objeto.value:objeto.id;
                  break;
            case "factura_pais_id":
                  codigo=objeto.codigo?objeto.codigo:objeto.id;
                  campo_codigo="codigo_pais";
                  cliente[campo] = objeto.value?objeto.value:objeto.id;
                  break;
            case "banco_id":
                  codigo=objeto.clave;
                  campo_codigo="clave_banco"; 
                  cliente[campo] = objeto.id;
                  rfc_banco=objeto.rfc;
                  nombre_banco=objeto.nombre;
                  break;           
        }  
       if(vacio==1){
        console.log('vaciar')
        codigo=valor;
        cliente[campo] =0;
          rfc_banco="";
         nombre_banco="";
       }
       if(campo=="banco_id"){
        self.setState({
            cliente : cliente,           
            [campo_codigo]:codigo,
            modal:false, 
            rfc_banco:rfc_banco,
            nombre_banco:nombre_banco,    
        })

       }else{
        self.setState({
            cliente : cliente,           
            [campo_codigo]:codigo,
            modal:false,         
        })
       }
       
    
        // self.setState({
        //     cliente : cliente,           
        //     [campo_codigo]:codigo,
        //     modal:false,         
        // })


    }  

    handleSelectChange(select, name) {

        
        const value = select === null ? null : select.value;
        this.setState({
            cliente: {
                ...this.state.cliente,
                [name]: value
            }
        });
        
        

        

        

    }

     toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }

    handleChangeTipo(tipo)
    {
        let {cliente}         = this.state;
        cliente.tipo_id    = tipo.value;
        this.setState({cliente: cliente});

    }

     handleChangerfc()
    {
        let {cliente}         = this.state;
        cliente.rfc    = "XAXX010101000";
        this.setState({cliente: cliente});
    }
    componentDidMount()
    {
         
        let prospectoid = this.props.prospectoid;
        let self = this;
         api().get('/formulario_cliente')
        .then(function(response)
        {
            self.setState({
               metodos : response.data.metodos,
                formas : response.data.formas,
                usos : response.data.usos,
                tipos : response.data.tipos,
                usuarios : response.data.usuarios,
            });
           
        })

        if(prospectoid > 0 && prospectoid != self.state.cliente.id)
        {

            api().get(`cliente/${prospectoid}`)
            .then(function(response)
            {
                  
                if(response.status === 200)
                {                
                    self.setState({
                        cliente: response.data,
                        action: 'update_cliente',
                        codigo_via_emb:parseInt(response.data.via_emb)>0?response.data.via_emb:'',
                        codigo_lab:parseInt(response.data.lab)>0?response.data.lab:'',
                        codigo_descuento:parseInt(response.data.codigo_descuento)>0?response.data.codigo_descuento:'',
                        codigo_terminos:parseInt(response.data.term_pago)>0?response.data.term_pago:'',
                        codigo_pais:response.data.codigo_pais,
                        rfc_banco:response.data.rfc_banco,
                        clave_banco:response.data.clave_banco,
                        nombre_banco:response.data.nombre_banco,
                    });

                }

            });
            // this.props.get_usuarios(prospectoid);
        }
        else if(prospectoid == null && self.state.cliente.id)
        {            
            self.resetModal();
        }
    }

   

    resetModal(){
        this.setState({
            cliente: {
                activo:true,
                ciudad:'',
                codigo_comision:'',
                codigo_descuento:'',
                codigo_postal:'',
                codigo_precio:'',
                factura_electronica:false,
                lab:'',
                term_pago:'',
                fax:'',
                via_emb:'',
                cta_contable:'',
                dias_pago:0,
                dias_revision:0,
                enc_pagos:'',
                limite_credito:0,
                plazo_credito:0,
                zona:'',
                exceder_credito:false,
                mayoreo:false,
                modificar:false,
                vendedor_id:1,
                codigo_postal:'',
                id:0,
               cliente: '',
               contacto : '',
               correo : '',
               rSocial : '',
               rfc : '',
               domicilio : '',
               telefono: '',
               ciudad : '',
               tipo_id:1,
               nota:'',

factura_calle:"",
factura_cliente:"",
factura_colonia:"",
factura_condicion:"",
factura_cp:"",
factura_estado:"",
factura_forma:1,
factura_localidad:"",
factura_metodo:1,
factura_municipio:"",
factura_num_ext:"",
factura_num_int:"",
factura_pais:"",
factura_referencia:"",
            },
            action: 'save_cliente',
             activeTab: '1',
              modal:false,
            titulo:'',
            tabla_modal:0,
            campo_modal:'',

            codigo_lab:'',
            codigo_via_emb:'',
            codigo_descuento:'',
            codigo_terminos:'',
        });
        
    }

    resetUser(){
        this.setState({
         usuario:
            {
                id:null,
                name:"",
                email:"",
                password:"",
                departamento:10,
                rol:0,
                 cliente_id:this.props.prospectoid,
            },
            });
    }



    handleInputChange(event) {
        let {cliente} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        if(target.type === 'checkbox'){
            value=0;
            if(target.checked)
                value=1;
        }

        cliente[name] = value;
        console.log('Cliente aqui----->',cliente)
        this.setState({
            cliente : cliente
        });
    }
    handleInputChange2(event) {
        let {usuario} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        // if(target.type === 'checkbox'){
        //     value='0';
        //     if(target.checked)
        //         value='1';
        // }

        usuario[name] = value;
        this.setState({
            usuario : usuario
        });
    }
    CrearUsuario(evt)
    {
        evt.preventDefault();
        let {usuario} = this.state;
        let self = this;
  

       this.props.save_usuario(usuario, () => {
            swal({
                title: 'Usuario',
                text: 'Usuario agregado correctamente!',
                type: 'success',
                // showCancelButton: true,
                // confirmButtonColor: '#3085d6',
                // cancelButtonColor: '#d33',
                confirmButtonText: 'Continue!'
            }).then((result) => {
                if (result.value) {
                    // swal(
                    //  'Deleted!',
                    //  'Your file has been deleted.',
                    //  'success'
                    //  )
                   
                    self.resetUser();
                }
            })
        });


    }

     objeto_mayusculas(objeto){
         for (var key in objeto) {
                if (objeto.hasOwnProperty(key)) {
                    // var valor=String(objeto[key]).toUpperCase();                 
                    // console.log('valor---->',valor)
                     
                         objeto[key] = String(objeto[key]).toUpperCase() ;
                         if( String(objeto[key]).toUpperCase()==='NULL')
                            objeto[key] ='';
                     
                    // console.log(key + " = " + objeto[key]);
                }
              }
              return objeto;
    }

    handleSubmit(evt)
    {
        evt.preventDefault();
        let {cliente} = this.state;
        let action=this.state.action;
        console.log("action---->",action)
        let save=true;
        let dato="";
        let self = this;
        var patt = new RegExp("[a-zA-Z0-9]?[a-zA-Z0-9]{11}[a-zA-Z0-9]$", "i");


        if(cliente.rfc.length>11&&cliente.rfc.search(patt)==0){
            let check = ['rfc', 'cliente','telefono'];

            for(let i in check) {

            let key = check[i];

            let value = cliente[key];
            dato=key;

            if(value == '' || value == null){
                save = false;
                break;
            }
                
            }


            


        if(save){
             cliente=this.objeto_mayusculas(cliente);


              api().post(`/validacion_cliente`, cliente)
        .then(function(response)
        {
            
           let result= response.data;
           console.log(result);
           console.log(result.encontrado.length)
           
            
            if(result.encontrado.length===0||parseInt(cliente.id)>0){


                  self.props[action](cliente, (data) => {
                    swal({
                        title: 'Cliente',
                        text: 'Cliente agregado correctamente!',
                        type: 'success',
                        // showCancelButton: true,
                        // confirmButtonColor: '#3085d6',
                        // cancelButtonColor: '#d33',
                        confirmButtonText: 'Continue!'
                    }).then((result) => {
                        if (result.value) {
                            // swal(
                            //  'Deleted!',
                            //  'Your file has been deleted.',
                            //  'success'
                            //  )
                            if(action==='update_cliente')
                                self.props.get_cliente(data);
                           
                            self.props.toggle();
                            self.resetModal();
                        }
                    })
                });

            }else{

                if(cliente.rfc==="XAXX010101000"){
                    swal("Oops..", "No se registro el cliente por que Se encontro un cliente con los mismos datos ");

                }else{
                    swal("Oops..", "No se registro el cliente por que  Se encontro un cliente con el mismo RFC  ");

                }

                 
            }


          });

        }else{
            swal("Oops..", "Por favor Verificar el Campo de " +dato);

        }

        


        }else{
            swal("Oops..", "Por favor Verificar el RFC ");
        }

      

    }

    render()
    {

        let {cliente,usuario,tipos}=this.state;
  
        
        return(

           <Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal-80 modal_cliente">
                <form  onSubmit={this.handleSubmit}>
                <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                     <Nav tabs>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '1' })}
                          onClick={() => { this.toggle_tab('1'); }}
                        >
                          Datos Cliente
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '2' })}
                          onClick={() => { this.toggle_tab('2'); }}
                        >
                         Nota
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '3' })}
                          onClick={() => { this.toggle_tab('3'); }}
                        >
                          Datos Facturación
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                      <TabPane tabId="1">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 form_cliente">
                        <div className="col-md-9">
                            <FormGroup>
                                <Label>Cliente *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="cliente"
                                    value={cliente.cliente}
                                    onChange={ this.handleInputChange}
                                    required
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-3 pt-3">
                                    <div className="form-group mt-4">
                                    <label >
                                        <input type="checkbox"
                                        name="factura_electronica" 
                                        checked={cliente.factura_electronica }
                                        onChange={this.handleInputChange}
                                        />&nbsp;&nbsp;Fact. Electronica
                                    </label>
                                    </div>
                                </div>
                        <div className="col-md-12">
                            <FormGroup>
                                <Label>Razon social *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="rSocial"
                                    value={cliente.rSocial}
                                    onChange={ this.handleInputChange}
                                    required
                                    />
                            </FormGroup>
                        </div>
                         <div className="col-md-12">
                            <FormGroup>
                                <Label>Domicilio *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="domicilio"
                                    value={cliente.domicilio}
                                    onChange={ this.handleInputChange}
                                    required
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-4">
                            <FormGroup>
                                <Label>Ciudad *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="ciudad"
                                    value={cliente.ciudad}
                                    onChange={ this.handleInputChange}
                                    required
                                    />
                            </FormGroup>
                        </div>
                         <div className="col-md-4">
                            <FormGroup>
                                <Label>Codigo Postal *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="codigo_postal"
                                    value={cliente.codigo_postal}
                                    onChange={ this.handleInputChange}
                                    required
                                    />
                            </FormGroup>
                        </div>
                         <div className="col-md-4">
                            <FormGroup>
                                <Label>CURP </Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="curp"
                                    value={cliente.curp}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>Contacto *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="contacto"
                                    value={cliente.contacto}
                                    onChange={ this.handleInputChange}
                                    required
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>Correo electronico </Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="correo"
                                    value={cliente.correo}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                          <div className="col-md-4">
                            <FormGroup>
                                <Label>Telefonos *</Label>
                                    <Input
                                    placeholder=""
                                    type="tel"
                                    name="telefono"
                                    value={cliente.telefono}
                                    onChange={ this.handleInputChange}
                                    required
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-4">
                            <FormGroup>
                                <Label>Fax</Label>
                                    <Input
                                    placeholder=""
                                    type="tel"
                                    name="fax"
                                    value={cliente.fax}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                        
                         <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label className>Tipo:</label>
                                                        <Select
                                                            placeholder=""
                                                            type="text"
                                                            name="tipo_id"
                                                            options={tipos}
                                                            value={parseInt(cliente.tipo_id) || ""}
                                                            onChange={ this.handleChangeTipo }
                                                            clearable={false}
                                                        />
                                                    </div>
                                                </div>
                        

                        
                        <div className="col-md-4">
                            <FormGroup>
                                <Label>RFC *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="rfc"
                                    maxLength={13}
                                    value={cliente.rfc}
                                    onChange={ this.handleInputChange}
                                    required
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-sm-3 pt-3">
                            <div className="form-group mt-4">
                                      <label >
                        <input type="checkbox"
                                name="promovido" 
                                checked={cliente.rfc==="XAXX010101000"?true:false}
                               
                                onChange={this.handleChangerfc}
                         />&nbsp;&nbsp;
                        Publico General
                    </label>
                            </div>
                        </div>
                         <div className="col-md-5">
                                <div className="form-group">
                                    <label className>Vendedor:</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="vendedor_id"
                                        options={this.state.usuarios}
                                        value={parseInt(cliente.vendedor_id) || ""}
                                        onChange={ (select) => { this.handleSelectChange(select, 'vendedor_id') } }
                                        clearable={false}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                            <div className="row">
                                <div className="col-sm-2 pt-3">
                                    <div className="form-group mt-4">
                                    <label >
                                        <input type="checkbox"
                                        name="activo" 
                                        checked={cliente.activo }

                                        onChange={this.handleInputChange}
                                        />&nbsp;&nbsp;
                                        Cliente Activo
                                    </label>
                                    </div>
                                </div>
                                <div className="col-sm-2 pt-3">
                                    <div className="form-group mt-4">
                                    <label >
                                        <input type="checkbox"
                                        name="modificar" 
                                        checked={cliente.modificar }
                                        onChange={this.handleInputChange}
                                        />&nbsp;&nbsp;
                                        Modificar al Fact.
                                    </label>
                                    </div>
                                </div>
                                <div className="col-sm-2 pt-3">
                                    <div className="form-group mt-4">
                                    <label >
                                        <input type="checkbox"
                                        name="mayoreo" 
                                        checked={cliente.mayoreo }
                                        onChange={this.handleInputChange}
                                        />&nbsp;&nbsp;
                                        Precio por vol.
                                    </label>
                                    </div>
                                </div>
                                <div className="col-sm-2 pt-3">
                                    <div className="form-group mt-4">
                                    <label >
                                        <input type="checkbox"
                                        name="credito" 
                                        checked={cliente.credito }
                                        onChange={this.handleInputChange}
                                        />&nbsp;&nbsp;Mod. Credito
                                    </label>
                                    </div>
                                </div>
                                <div className="col-sm-3 pt-3">
                                    <div className="form-group mt-4">
                                    <label >
                                        <input type="checkbox"
                                        name="exceder_credito" 
                                        checked={cliente.exceder_credito }
                                        onChange={this.handleInputChange}
                                        />&nbsp;&nbsp;Permitir Excederlo
                                    </label>
                                    </div>
                                </div>
                                 

                            </div>
                            </div>


                        <div className="col-md-12">
                        <div className="row">
                        <div className="col-md-3"> 
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className>Cts Contable:</label>
                                    <Input
                                    placeholder=""
                                    type="tel"
                                    name="cta_contable"
                                    value={cliente.cta_contable}
                                    onChange={ this.handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className>Codigo Comision:</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="codigo_comision"
                                        options={codigos_precios}
                                        value={parseInt(cliente.codigo_comision) || ""}
                                       onChange={ (select) => { this.handleSelectChange(select, 'codigo_comision') } }
                                        clearable={false}

                                    />
                                </div>
                            </div>
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className>Zona:</label>
                                    <Input
                                    placeholder=""
                                    type="tel"
                                    name="zona"
                                    value={cliente.zona}
                                    onChange={ this.handleInputChange}
                                    />
                                </div>
                            </div>                                                                                    
                        </div>
                        <div className="col-md-3"> 
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className>Limite de credito:</label>
                                    <Input
                                    placeholder=""
                                    type="tel"
                                    name="limite_credito"
                                    value={cliente.limite_credito}
                                    onChange={ this.handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className>Plazo Credito:</label>
                                    <Input
                                    placeholder=""
                                    type="tel"
                                    name="plazo_credito"
                                    value={cliente.plazo_credito}
                                    onChange={ this.handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className>Enc/Pagos:</label>
                                    <Input
                                    placeholder=""
                                    type="tel"
                                    name="enc_pagos"
                                    value={cliente.enc_pagos}
                                    onChange={ this.handleInputChange}
                                    />
                                </div>
                            </div>                                                                                   
                        </div>
                        <div className="col-md-3"> 
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className>Dias de Pago:</label>
                                    <Input
                                    placeholder=""
                                    type="tel"
                                    name="dias_pago"
                                    value={cliente.dias_pago}
                                    onChange={ this.handleInputChange}
                                    />
                                </div>
                            </div> 
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className>Dias/Revision:</label>
                                    <Input
                                    placeholder=""
                                    type="tel"
                                    name="dias_revision"
                                    value={cliente.dias_revision}
                                    onChange={ this.handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className>Codigo de precio:</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="codigo_precio"
                                        options={codigos_precios}
                                        value={parseInt(cliente.codigo_precio) || ""}
                                       onChange={ (select) => { this.handleSelectChange(select, 'codigo_precio') } }
                                        clearable={false}

                                    />
                                </div>
                            </div>
                                                                                 
                        </div>
                        <div className="col-md-3"> 
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className>Codigo de Descto:</label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="codigo_descuento"
                                    value={this.state.codigo_descuento}
                                    onChange={ this.ChangeCode}
                                    onBlur={this.handleClose}
                                    className="input_button"
                                    />
                                     <Button onClick={ (button) => { this.toggle_modal(24,"Descuentos","codigo_descuento") } }>...</Button>
                                </div>
                            </div>
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className="d-block">Codigo Via/Emb:</label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="codigo_via_emb"
                                    value={this.state.codigo_via_emb}
                                    onChange={ this.ChangeCode}
                                    onBlur={this.handleClose}
                                    className="input_button"
                                    />
                                    <Button onClick={ (button) => { this.toggle_modal(21,"Vias de Embarque","via_emb") } }>...</Button>
                                </div>
                            </div>
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className="d-block">Codigo de Lab:</label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="codigo_lab"
                                    value={this.state.codigo_lab}
                                    onChange={ this.ChangeCode}
                                    onBlur={this.handleClose}
                                    className="input_button"                                    
                                    />
                                    <Button onClick={ (button) => { this.toggle_modal(22,"Conceptos Lab","lab") } }>...</Button>
                                </div>
                            </div>
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className>Codigo Term/Pago:</label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="codigo_terminos"
                                    value={this.state.codigo_terminos}
                                    onChange={ this.ChangeCode}
                                    onBlur={this.handleClose}
                                    className="input_button"
                                    />
                                     <Button onClick={ (button) => { this.toggle_modal(23,"Terminos de Pago","term_pago") } }>...</Button>
                                </div>
                            </div>
                        </div>


                        </div>
                        
                       
                        
                        
                      
                        </div>
                    </div>
                           
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="2">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 form_cliente">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className>Nota</label>
                                    <Input
                                      rows={10}                                                        
                                      type="textarea"
                                      name="nota"
                                      value={cliente.nota} 
                                      maxLength={450}
                                      onChange={ this.handleInputChange}
                                      />
                                    
                                </div>
                            </div>                                   
                                                      
                        </div>                          
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="3">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 form_cliente">
                          <div className="col-md-12">
                            <FormGroup>
                                <Label>Nombre</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="factura_cliente"
                                    value={cliente.factura_cliente}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-12">
                            <FormGroup>
                                <Label>Calle</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="factura_calle"
                                    value={cliente.factura_calle}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                         <div className="col-md-3">
                            <FormGroup>
                                <Label>Num Ext.</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="factura_num_ext"
                                    value={cliente.factura_num_ext}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-3">
                            <FormGroup>
                                <Label>Num Int
                                </Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="factura_num_int"
                                    value={cliente.factura_num_int}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>Colonia
                                </Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="factura_colonia"
                                    value={cliente.factura_colonia}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                         <div className="col-md-6">
                            <FormGroup>
                                <Label>Localidad
                                </Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="factura_localidad"
                                    value={cliente.factura_localidad}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                         <div className="col-md-6">
                            <FormGroup>
                                <Label>Municipio
                                </Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="factura_municipio"
                                    value={cliente.factura_municipio}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>Estado
                                </Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="factura_estado"
                                    value={cliente.factura_estado}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-2">
                            <FormGroup>
                                <Label>Codigo Postal
                                </Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="factura_cp"
                                    value={cliente.factura_cp}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-4">
                            <FormGroup>
                                <Label>Pais
                                </Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="factura_pais"
                                    value={cliente.factura_pais}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                         <div className="col-md-12">
                            <FormGroup>
                                <Label>Referencia
                                </Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="factura_referencia"
                                    value={cliente.factura_referencia}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-3"> 
                                <div className="form-group">
                                    <label className>Forma de Pago:</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="factura_forma"
                                        options={this.state.formas}
                                        value={parseInt(cliente.factura_forma) || ""}
                                       onChange={ (select) => { this.handleSelectChange(select, 'factura_forma') } }
                                        clearable={false}

                                    />
                                </div>
                            </div>
                            <div className="col-md-3"> 
                                <div className="form-group">
                                    <label className>Metodo de Pago:</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="factura_metodo"
                                        options={this.state.metodos}
                                        value={parseInt(cliente.factura_metodo) || ""}
                                        onChange={ (select) => { this.handleSelectChange(select, 'factura_metodo') } }
                                        clearable={false}

                                    />
                                </div>
                            </div>
                        
                        <div className="col-md-5"> 
                                <div className="form-group">
                                    <label className>Uso del CFDI:</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="factura_uso_id"
                                        options={this.state.usos}
                                        value={parseInt(cliente.factura_uso_id) || ""}
                                        onChange={ (select) => { this.handleSelectChange(select, 'factura_uso_id') } }
                                        clearable={false}

                                    />
                                </div>
                            </div>
                            <div className="col-md-3"> 
                                <div className="form-group ">
                                    <label className="d-block">Pais:</label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    maxLength={10}
                                    name="codigo_pais"
                                    value={this.state.codigo_pais}
                                    onChange={ this.ChangeCode}
                                    onBlur={this.handleClose}
                                    className="input_button"
                                    />
                                     <Button onClick={ (button) => { this.toggle_modal(5,"Paises","factura_pais_id") } }>...</Button>
                                </div>
                            </div>
                            <div className="col-md-4">
                            <FormGroup>
                                <Label>Registro de I. Fiscal
                                </Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="factura_registro_fiscal"
                                    value={cliente.factura_registro_fiscal}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>

                     







                          </div> 
                                             
                          </Col>
                        </Row>
                        <Row>
                                <Col sm="12">
                                    <div className="row mt-4 mb-4">
                                        <div className="col-md-12 div_titulo mr-2">
                                         <h1><span>Datos Bancarios</span></h1>
                                         <div className="row" >
                                          <div className="col-md-4"> 
                                                <div className="form-group">
                                                    <label className="d-block">Clave Banco </label>
                                                    <Input
                                                    placeholder=""
                                                    type="number"
                                                    name="clave_banco"
                                                    value={this.state.clave_banco}
                                                     onChange={ this.ChangeCode}
                                                     onBlur={this.handleClose}
                                                    className="input_button_sm"
                                                  
                                                    />
                                                    <Button onClick={ (button) => { this.toggle_modal(0,"Bancos","banco_id") } }>...</Button>
                                                </div>
                                            </div>
                                         </div>
                                            <div className="row ">
                                       
                                                <div className="col-md-6">
                                                    <FormGroup>
                                                        <Label>Nombre *</Label>
                                                        <Input
                                                        placeholder=""
                                                        type="text"
                                                        name="nombre_emisor"
                                                        
                                                        value={this.state.nombre_banco}
                                                        onChange={ this.handleInputChange}
                                                        readOnly
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-3">
                                                    <FormGroup>
                                                        <Label>RFC *</Label>
                                                            <Input
                                                            placeholder=""
                                                            type="text"
                                                            name="rfc_emisor"
                                                            
                                                            value={this.state.rfc_banco}
                                                            onChange={ this.handleInputChange}
                                                            readOnly
                                                            />
                                                    </FormGroup>
                                                </div>
                                                 <div className="col-md-3">
                                                    <FormGroup>
                                                        <Label>Ciuenta *</Label>
                                                            <Input
                                                            placeholder=""
                                                            type="text"
                                                            name="cuenta"
                                                            value={cliente.cuenta}
                                                            onChange={ this.handleInputChange}
                                                            />
                                                    </FormGroup>
                                                </div>

                                            </div>
                                        </div>
                                    
                                    </div>                    
                                </Col>
                            </Row>
                            <br/><br/>
                          <br/>      
                          <br/> 
                      </TabPane>
                    </TabContent>
                    
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.cliente.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit"  >
                                <IconSave />&nbsp;Guardar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                </form>
                <ModalTablas
                    open={this.state.modal}
                    toggle={this.toggle_modal}                  
                    titulo={this.state.titulo}
                    catalogo={this.state.tabla_modal}
                    retorno={this.retorno}
                    campo={this.state.campo_modal}
                    agregar={this.toggle_modal_registro}
                    />

                {
                   this.state.modal_registro==21&& 
                   <Embarques 
                 open={this.state.modal_registro} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
                {
                   this.state.modal_registro==22&& 
                   <LAB
                 open={this.state.modal_registro} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
                {
                   this.state.modal_registro==24&& 
                   <Descuentos
                 open={this.state.modal_registro} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
                {
                   this.state.modal_registro==23&& 
                   <Terminos
                 open={this.state.modal_registro} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
            </Modal>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        cliente : state.cliente,
    }
};

export default connect(mapStateToProps, actions)(ClienteModal)


// WEBPACK FOOTER //
// ./src/views/clientes/Modal.js